function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9d9d8e",
  d: "M10.951 2.347h2.142l1.18 2.346H10.95zm-6.57 7.04c.646 0 1.173.526 1.173 1.173a1.175 1.175 0 0 1-2.347 0c0-.647.526-1.173 1.173-1.173zm8.017 0a1.175 1.175 0 0 1 0 2.347 1.175 1.175 0 0 1 0-2.347zm0 3.52c1.085 0 2-.74 2.268-1.74h1.702a.587.587 0 0 0 .587-.587V6.766a.588.588 0 0 0-.123-.36l-1.094-1.408v-.001l-1.76-3.5a.587.587 0 0 0-.524-.324h-2.503V.587A.587.587 0 0 0 10.365 0H.587a.587.587 0 1 0 0 1.173h9.19V5.28c0 .324.264.587.588.587h4.562l.855 1.1v3.026h-1.106a2.35 2.35 0 0 0-2.278-1.78 2.35 2.35 0 0 0-2.277 1.78H6.658a2.35 2.35 0 0 0-2.278-1.78 2.35 2.35 0 0 0-2.277 1.78H.586a.587.587 0 1 0 0 1.174h1.527a2.35 2.35 0 0 0 2.267 1.74c1.085 0 2-.74 2.268-1.74h3.483a2.35 2.35 0 0 0 2.267 1.74z"
})));

var SvgFreight = function SvgFreight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFreight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/freight.a97fc835.svg";
export { ForwardRef as ReactComponent };